export const useRegion = () => {
  // Current region state: 'CH' or 'FR'
  // Default to 'CH' (Suisse)
  const currentRegion = useState("region", () => "CH");

  // Computed properties based on region
  const isSwiss = computed(() => currentRegion.value === "CH");
  const isFrance = computed(() => currentRegion.value === "FR");

  const currency = computed(() => (isSwiss.value ? "CHF" : "€"));

  // Multiplier for price conversion if needed (1 CHF ~= 1.06 EUR)
  const priceMultiplier = computed(() => (isSwiss.value ? 1 : 1.06));

  const countryNameKey = computed(() =>
    isSwiss.value ? "common.suisse" : "common.france",
  );
  const countryAdjKey = computed(() =>
    isSwiss.value ? "common.suisse_adj" : "common.france_adj",
  );
  const flag = computed(() => (isSwiss.value ? "🇨🇭" : "🇫🇷"));

  // Toggle function
  const toggleRegion = () => {
    currentRegion.value = currentRegion.value === "CH" ? "FR" : "CH";
  };

  const setRegion = (region: "CH" | "FR") => {
    currentRegion.value = region;
  };

  // Format price with thousands separator (generic tool)
  const formatPrice = (value: number | string) => {
    return formatNumber(value, isSwiss.value ? "fr-CH" : "fr-FR");
  };

  // Format with currency symbol
  const formatValueWithCurrency = (value: number | string) => {
    const numericValue = typeof value === "string" ? parseFloat(value) : value;
    const convertedValue = numericValue * priceMultiplier.value;

    return formatCurrency(
      convertedValue,
      currency.value === "CHF" ? "CHF" : "EUR",
      isSwiss.value ? "fr-CH" : "fr-FR",
    );
  };

  return {
    currentRegion,
    isSwiss,
    isFrance,
    currency,
    priceMultiplier,
    countryNameKey,
    countryAdjKey,
    flag,
    toggleRegion,
    setRegion,
    formatPrice,
    formatValueWithCurrency,
  };
};
